export const MODAL_TITLE = 'Payment';
export const SUCCESS_MSG = 'Your payment in progress';